import { LoversLiveForeverLogo } from "components/LoversLiveForeverLogo"
import { Link } from "react-router-dom"

export const PrivacyPolicyPage = () => {
  return (
    <>
      <header className="inset-x-0">
        <nav
          aria-label="Global"
          className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8"
        >
          <div className="flex lg:flex-1">
            <Link to="/" className="-m-1.5 p-1.5">
              <span className="sr-only">Lovers live forever</span>
              <LoversLiveForeverLogo className="h-20 w-auto" />
            </Link>
          </div>
        </nav>
      </header>
      <div className="max-w-4xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">
          Privacy Policy
        </h1>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
            1. Information We Collect
          </h2>
          <p className="text-gray-600 dark:text-gray-300 leading-relaxed mb-4">
            We collect minimal personal information necessary to provide our time capsule
            service:
          </p>
          <ul className="list-disc pl-5 space-y-2 text-gray-600 dark:text-gray-300">
            <li>Email address (for account creation and notifications)</li>
            <li>Display name (for identification within the service)</li>
            <li>Profile picture (optional)</li>
            <li>Time capsule content (entries you create)</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
            2. How We Use Your Information
          </h2>
          <ul className="list-disc pl-5 space-y-2 text-gray-600 dark:text-gray-300">
            <li>To create and maintain your account</li>
            <li>To store and manage your time capsules</li>
            <li>To send notifications about your time capsules</li>
            <li>To facilitate collaboration with other users you invite</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
            3. Cookies
          </h2>
          <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
            We use only essential cookies for authentication purposes. These cookies are
            HTTP-only and are used solely to maintain your login session.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
            4. Third-Party Service Providers
          </h2>
          <p className="text-gray-600 dark:text-gray-300 leading-relaxed mb-4">
            We use the following service providers to operate our service:
          </p>
          <ul className="list-disc pl-5 space-y-2 text-gray-600 dark:text-gray-300">
            <li>Resend (for sending email notifications)</li>
            <li>Google Cloud Storage (for file storage)</li>
            <li>Xata (for database services)</li>
            <li>Hetzner (for hosting)</li>
          </ul>
          <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-4">
            These providers may process your data according to their own privacy policies.
            They are only permitted to use the data we share with them to provide services
            to us.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
            5. Data Retention
          </h2>
          <ul className="list-disc pl-5 space-y-2 text-gray-600 dark:text-gray-300">
            <li>
              Your account and all associated data remain active until you choose to
              delete them
            </li>
            <li>
              When you delete your account, all your data is immediately and permanently
              removed from our systems
            </li>
            <li>
              Time capsules (both opened and unopened) remain stored until explicitly
              deleted by you
            </li>
            <li>
              Email delivery logs may be retained by our email service provider (Resend)
              according to their privacy policy
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
            6. Your Rights
          </h2>
          <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
            You have the right to:
          </p>
          <ul className="list-disc pl-5 space-y-2 text-gray-600 dark:text-gray-300">
            <li>Access your personal data</li>
            <li>Correct any inaccurate personal data</li>
            <li>Delete your account and associated data</li>
            <li>Request information about how your data is processed</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
            7. Data Security
          </h2>
          <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
            We implement appropriate security measures to protect your personal
            information against unauthorized access, alteration, disclosure, or
            destruction. Time capsule content remains encrypted and private until its
            designated opening date.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
            8. Changes to This Policy
          </h2>
          <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
            We may update this privacy policy from time to time. We will notify you of any
            significant changes by email or through the service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
            9. Contact Us
          </h2>
          <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
            If you have any questions about this privacy policy or our data practices,
            please contact us at{" "}
            <a
              href="mailto:privacy@loversliveforever.com"
              className="underline font-medium"
            >
              privacy@loversliveforever.com
            </a>
          </p>
        </section>
      </div>
    </>
  )
}
